export default __webpack_public_path__ + "static/corners-do-b9fc7b5bcf7ea5fd38c68b7653471fdb.png";